import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import { IContextService, DomainContext, PershingTranslationService, IAuthorizationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { BlanceKeyRestService } from '../../services/NXI-Balances.services';
import { NxiContextUtils } from '@pershing/nxi-common';
declare let dojoApp: any;
@Component({
    selector: 'history-Summary',
    templateUrl: './dojo-HistorySummary.component.html'
})
export class DojoHistorySummaryComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: string;
    nxiRestServiceUrl: any;
    nxiRateBoardServiceUrl: any;
    activitySummaryParams: any;
    activityDownloadLinkParams: any;
    activityData: any;
    finalDate: any;
    isAdvisor: boolean = false;
    isAdaTheme: boolean = false;
    title: string;
    showFELink: boolean = false;
    showPCLink: boolean = false;
    entjson: string[];
    ismobile: boolean = false;
    group: boolean = false;
    isTRP: boolean = false;
    isTradelink: boolean = false;
    isMiddlewareJarBasedApproachEnabledForRateboard: boolean = false;
    constructor(private contextService: IContextService,
                private translationService: PershingTranslationService,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private authService: IAuthorizationService,
                @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.nxiRestServiceUrl = this.nxiRestService.serviceUrl;
        this.nxiRateBoardServiceUrl = this.nxiRestService.rateboardServiceUrl;
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
            this.title = 'history-Summary';
        }
        if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
            this.ismobile = true;
        }
        this.isAdvisor = appSettings.isAdvisor;
        if (appSettings.deviceType && appSettings.deviceType === 'desktop') {
            this.showFELink = appSettings.entitlementJson.includes('FOREIGN_CURRENCY_DISPLAY');
            this.showPCLink = appSettings.entitlementJson.includes('HISTORIC_DATA');
        }
        if (appSettings.ibdConfigMap.IBD && appSettings.ibdConfigMap.IBD === '30A') {
            this.isTRP = true;
        }
        if (appSettings.ibdConfigMap.community && appSettings.ibdConfigMap.community === 'tradelink') {
            this.isTradelink = true;
        }
        if (appSettings.ibdConfigMap.hasOwnProperty('isMiddlewareJarBasedApproachEnabledForRateboard')) {
            this.isMiddlewareJarBasedApproachEnabledForRateboard = appSettings.ibdConfigMap.isMiddlewareJarBasedApproachEnabledForRateboard;
        }
    }
    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            if (domainContext.domain === 'group') {
                this.group = true;
            }
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getActivitySummaryDownload();
        });

    }

    ngOnDestroy(): void {
        console.log('In dojo Activity destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyHistorySummary();
        }
    }
    renderDojoWidget(activitySummaryDojoParams: any, activityDownloadLinkParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            activitySummaryDojoParams.nxiRestBaseUrl = this.nxiRestServiceUrl;
            activitySummaryDojoParams.isAdvisor = this.isAdvisor;
            dojoApp.renderHistorySummary(this.acctRef, activitySummaryDojoParams, activityDownloadLinkParams);

        }
    }
    getActivitySummaryDownload() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'activity').subscribe(
                resp => {
                    console.log('Retrived common REST Activity Summary params : ', resp.response);
                    if (resp.response) {
                        resp.response.storeUrl = this.nxiRestServiceUrl + resp.response.storeUrl;
                        resp.response.modAPIUrl = 'https://api-netxselect.wsodqa.com';
                        this.activitySummaryParams = resp.response;
                        this.finalDate = resp.response.asOfDate;
                        this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'activityLinkData').subscribe(
                            res => {
                                console.log('Retrived common REST Activity Download params : ', res.response);
                                if (res.response) {
                                    res.response.downloadUrl = this.nxiRestServiceUrl + res.response.downloadUrl;
                                    this.activityDownloadLinkParams = res.response;
                                    this.renderDojoWidget(this.activitySummaryParams, this.activityDownloadLinkParams);
                                }
                            }
                        );
                    }
                }
            );
        }
    }
    openFXRate() {
        if (this.isMiddlewareJarBasedApproachEnabledForRateboard) {
            dojoApp.renderopenFXRate(this.nxiRestServiceUrl +  "/portfolio/fxRate");
        } else {
            dojoApp.renderopenFXRate(this.nxiRateBoardServiceUrl + "/fxRate" );
        }        
    }
    gotoRoute(page: string): void {
        if (this.inputValue === 'ALL_ACCOUNTS' || this.group) {
            this.nxiRestService.getAccountList().subscribe(data => {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].primaryAcct) {
                        this.acctRef = data[i].acctReference;
                        document.dispatchEvent(new CustomEvent('portal.gotoview', {
                            detail: {
                                'gotoPage': page,
                                'context': { 'domain': 'account', 'value': this.acctRef }
                            }
                        }));
                        break;
                    }
                }
            },
            error => {
            });
        } else {
            document.dispatchEvent(new CustomEvent('portal.gotoview', {
                detail: {
                    'gotoPage': page,
                    'context': { 'domain': 'account', 'value': this.acctRef }
                }
            }));
        }
    }
}
